import { render, staticRenderFns } from "./AcademiaHepta.vue?vue&type=template&id=ed19968a&scoped=true"
import script from "./AcademiaHepta.vue?vue&type=script&lang=js"
export * from "./AcademiaHepta.vue?vue&type=script&lang=js"
import style0 from "./AcademiaHepta.vue?vue&type=style&index=0&id=ed19968a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed19968a",
  null
  
)

export default component.exports